import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "_mr-1",
  "data-qa": "days-left"
}
const _hoisted_2 = {
  class: "_mr-1",
  "data-qa": "hours-left"
}
const _hoisted_3 = {
  class: "_mr-1",
  "data-qa": "minutes-left"
}
const _hoisted_4 = {
  class: "_mr-1",
  "data-qa": "seconds-left"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.timeLeft.totalDays), 1 /* TEXT */),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-promo-banner__countdown-unit _mr-2" }, "days", -1 /* CACHED */)),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.timeLeft.hours), 1 /* TEXT */),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "gfu-promo-banner__countdown-unit _mr-2" }, "hours", -1 /* CACHED */)),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.timeLeft.minutes), 1 /* TEXT */),
    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "gfu-promo-banner__countdown-unit _mr-2" }, "minutes", -1 /* CACHED */)),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.timeLeft.seconds), 1 /* TEXT */),
    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "gfu-promo-banner__countdown-unit _mr-2" }, "seconds", -1 /* CACHED */))
  ]))
}